import initialState from '../initialstate';
import {uniqBy} from 'lodash';
import * as types from '../../actions/actiontypes';

export default function EngagementUserReducer(state = initialState.engagementUser, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_USER: {
			let _state = {...state};
			let response = uniqBy(action.response, 'employeeGUIID');
			_state[action.engagementId] = response;

			return _state;
		}
		default:
			return state;
	}
}
